var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticClass:"d-flex align-stretch"},[_c('v-col',{attrs:{"cols":"6"}},[_c('BillingCredit',{staticClass:"flex"})],1),_c('v-col',{attrs:{"cols":"6"}},[_c('BillingInvoices',{staticClass:"flex flex-column"})],1),_c('v-col',{attrs:{"cols":"12"}},[_c('BillingCreditUsage')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }